import { useLocation } from "react-router-dom"

import {
  PROJECT_ROOT
} from '../constants'

const routes = [
  { path: `${PROJECT_ROOT}/get-started` },
  { path: `${PROJECT_ROOT}/drop-contract` },
]

const useCookieGatedPathMatch = () => {
  const location = useLocation()
  let cookieGatedPathPatterns = routes.map((entry) => entry.path);

  let match = false;
  for(let routePattern of cookieGatedPathPatterns) {
    if (location?.pathname.indexOf(routePattern) > -1) {
      return true;
    }
  }

  return match;
}

export default useCookieGatedPathMatch;